/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";
import { StoreTabColorDecisionMaker } from "../../../../utils/chipColorDecisionMaker";
import OrderTableCell from "../../../orders/components/OrderTableCell";
import NotFound from "../../../../../../components/NotFound";
import DisputeTableCellRemake from "../../../orders/dispute_list/components/DisputeTableCellRemake";
import AdminPaymentDataTable from "../../../payments/components/AdminPaymentDataTable";
import AdminTablesPagination from "../../../../components/AdminTablesPagination";
import { getAllOrders } from "../../../../../../api/order";
import { getAllDisputes } from "../../../../../../api/order/disputes-admin";
import { getAllTransactions } from "../../../../../../api/transaction";
import { useDispatch, useSelector } from "react-redux";
import { transactionSelector } from "../../../../../../redux/slices/transactionSlice";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function StoreDetailsTab({
  value,
  setValue,
  isLoading,
  storeId,
  orders,
  totalOrders,
  disputes,
  totalDisputes,
  transactions,
  totalTransactions,
}) {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { isLoading:transactionLoading } = useSelector(transactionSelector);
  const dispatch = useDispatch()
  return (
    <Box
      sx={{
        paddingBottom: "20px",
        width: "100%",
        marginTop: "30px",
        boxShadow:
          " 0px 2px 2px rgb(145 158 171 / 20%), 0px 12px 24px -4px rgb(145 158 171 / 12%)",
      }}
    >
      <Box>
        <Tabs
          value={value}
          sx={{
            position: "relative",
            zIndex: 1,
            "& .Mui-Selected": {
              color: "red",
            },
          }}
          onChange={handleChange}
          aria-label="basic tabs example"
          inkBarStyle={{ backgroundColor: "#000" }}
        >
          <Tab
          onClick={() => dispatch(getAllOrders({ page: 0, size: 50, storeId: storeId }))}
            label={
              <div
                style={{
                  display: "flex",
                  fontWeight: value === 0 && "700",
                }}
              >
                {StoreTabColorDecisionMaker("Orders", totalOrders)}
                Orders
              </div>
            }
            {...a11yProps(0)}
          />
          <Tab
          onClick={() =>   dispatch(getAllDisputes({ page: 0, size: 50, storeId: storeId }))
          }
            label={
              <div
                style={{
                  display: "flex",
                  fontWeight: value === 1 && "700",
                }}
              >
                {StoreTabColorDecisionMaker("Disputes", totalDisputes)}
                Disputes
              </div>
            }
            {...a11yProps(1)}
          />
          <Tab
          onClick={() => dispatch(getAllTransactions({ page: 0, size: 50, storeId: storeId }))}
            label={
              <div
                style={{
                  display: "flex",
                  fontWeight: value === 2 && "700",
                }}
              >
                {StoreTabColorDecisionMaker("Transactions", totalTransactions)}
                Transactions
              </div>
            }
            {...a11yProps(2)}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        {orders?.length > 0 ? (
          <OrderTableCell data={orders} />
        ) : (
          <NotFound margin="5%" loading={isLoading} content="orders" subContent="haven't recieved any order" />
        )}
        <div
          style={{
            left: "45%",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Stack
            spacing={2}
            sx={{
              padding: "0 10px 0 0",
              borderRadius: "5px",
            }}
          >
            <AdminTablesPagination
              title="orders"
              count={totalOrders}
              storeId={storeId}
            />
          </Stack>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1} >
        {disputes?.length > 0 ? (
          <DisputeTableCellRemake disputeInfo={disputes} />
        ) : (
          <NotFound margin="5%" loading={isLoading} content="disputes" subContent="haven't opended any dispute" />
        )}
        <div
          style={{
            left: "45%",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Stack
            spacing={2}
            sx={{
              padding: "0 10px 0 0",
              borderRadius: "5px",
            }}
          >
            <AdminTablesPagination
              title="disputes"
              count={totalDisputes}
              storeId={storeId}
            />
          </Stack>
        </div>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <div style={{margin:"0px 15px"}}>
        {transactions?.length > 0 ? (
          <AdminPaymentDataTable transactions={transactions} />
        ) : (
          <NotFound margin="5%" loading={transactionLoading} content="transactions" subContent="heven't made any transaction" />
        )}
        </div>
        <div
          style={{
            left: "45%",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Stack
            spacing={2}
            sx={{
              padding: "0 10px 0 0",
              borderRadius: "5px",
            }}
          >
            <AdminTablesPagination
              title="transactions"
              count={totalTransactions}
              storeId={storeId}
            />
          </Stack>
        </div>
      </TabPanel>
    </Box>
  );
}
